import {Button, message} from "antd";
import './check-button.style.less';
import {ComplianceManagerApi} from "../compliance-manager";
import React from "react";

export function OverrideButton(props: { api: ComplianceManagerApi, style?: React.CSSProperties }) {
    const { api } = props;

    if (!api.paxContext?.paxNode) return null;

    return (
        <Button
            type="primary"
            onClick={() => api.setDrawerVisibility('overridePanel', true)}
            style={props.style}
        >
            OVERRIDE
        </Button>
    );
}